import PptxGenJS from 'pptxgenjs';

import LogRocket from 'logrocket';

import { createPresentation } from './createPresentation';
import { createTitleSlide } from './helpers/title_slide';
import { renderLegacyChartTableItem } from './legacy/renderLegacyChartTableItem';
import { renderLegacyNarrativeItem } from './legacy/renderLegacyNarrativeItem';

/** Downloads a validated canonical presentation while preserving app-wide export analytics. */
export const downloadPresentation = async (model) => {
  LogRocket.track('Flow_Ppt_Download');
  await createPresentation({ model });
};

/**
 * Legacy Narrative/Report-style PowerPoint entry point. New Report and Narratives Chat callers use
 * downloadPresentation with the validated canonical model; the fallback top-level { chart, table }
 * shape remains supported for callers that have not migrated.
 *
 * @param {Object} params
 * @param {String} [params.customFileName]
 * @param {Object} params.data export payload (see the two shapes above)
 * @returns {Promise<void>} writes `<fileName>.pptx`
 */
export const downloadPowerPointFile = async ({ customFileName, data }) => {
  const { exportName, reportDateRange, reportName, reportType, reportUrl, shopperAttributes } =
    data;

  LogRocket.track('Flow_Ppt_Download');

  const footer = { reportDateRange, reportType, reportUrl, shopperAttributes };

  // Legacy Narrative/Survey path: pre-typed topic items (`data.data`) or a single {chart, table}.
  const pptx = new PptxGenJS();
  createTitleSlide({ pptx, reportName, reportType });
  const items = Array.isArray(data?.data) ? data.data : [data];
  for (const item of items ?? []) {
    const itemProps = {
      pptx,
      reportDateRange,
      reportType,
      reportUrl,
      shopperAttributes,
      slideTitle: item?.title || null,
    };
    // eslint-disable-next-line no-await-in-loop
    const wasNarrativeItem = await renderLegacyNarrativeItem({ item, itemProps });
    if (!wasNarrativeItem) {
      renderLegacyChartTableItem({ footer, item, pptx });
    }
  }

  await pptx.writeFile({ fileName: `${customFileName || exportName}.pptx` });
};
